import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const entries = [
  {
    date: "May 2026",
    title: "Public discovery improvements",
    items: [
      "Added sitemap generation for public pages and help articles.",
      "Added structured data for the homepage, pricing page, features page, and help content.",
      "Added public pages that explain Jotform backup, restore, form recovery, and SaaS backup use cases.",
    ],
  },
  {
    date: "April 2026",
    title: "Jotform backup and billing refinements",
    items: [
      "Improved Jotform-focused backup and restore guidance.",
      "Aligned public pricing around matched Jotform plan tiers.",
      "Expanded help content for backups, restores, billing states, and troubleshooting.",
    ],
  },
];

const ChangelogPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow container mx-auto px-6 py-12 md:py-20 max-w-4xl">
        <header className="mb-12">
          <p className="text-sm font-semibold text-primary mb-3">Product updates</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">FAB Changelog</h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Public summary of notable product, documentation, and discovery improvements.
          </p>
        </header>

        <div className="space-y-8">
          {entries.map((entry) => (
            <article key={entry.title} className="border rounded-lg p-6 bg-card">
              <p className="text-sm text-muted-foreground">{entry.date}</p>
              <h2 className="mt-2 text-2xl font-semibold text-foreground">{entry.title}</h2>
              <ul className="mt-4 space-y-2 text-muted-foreground list-disc pl-5">
                {entry.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ChangelogPage;
